import { createGlobalStyle } from 'styled-components';

export const GlobalTheme = createGlobalStyle`
  body {
    font-family: 'Noto Sans', sans-serif; 
  }

  * {
    box-sizing: border-box;
  }
`;
